import { AntecipacaoCategoria } from '../generated/backend-enums.js';
export { AntecipacaoCategoria };
/** Rótulo de cada categoria — a palavra que o usuário usa, não o código do enum. */
export const AntecipacaoCategoriaMap = {
    [AntecipacaoCategoria.ESPACO]: 'Espaço',
    [AntecipacaoCategoria.AEB]: 'A&B',
    [AntecipacaoCategoria.ARTISTICO]: 'Artístico',
    [AntecipacaoCategoria.LOGISTICA]: 'Logística',
    [AntecipacaoCategoria.MATERIAL_GRAFICO]: 'Material Gráfico',
    [AntecipacaoCategoria.CENOGRAFIA]: 'Cenografia',
    [AntecipacaoCategoria.TECNICA]: 'Técnica',
    [AntecipacaoCategoria.TECNOLOGIA]: 'Tecnologia',
    [AntecipacaoCategoria.SERVICOS]: 'Serviços',
    [AntecipacaoCategoria.OUTROS]: 'Outros',
};
/**
 * Ordem de exibição na tela de criação e no detalhamento. Explícita para o layout não depender
 * da ordem de declaração do enum, e para `OUTROS` ficar sempre por último (é a válvula de escape).
 */
export const ANTECIPACAO_CATEGORIAS_ORDENADAS = [
    AntecipacaoCategoria.ESPACO,
    AntecipacaoCategoria.AEB,
    AntecipacaoCategoria.ARTISTICO,
    AntecipacaoCategoria.LOGISTICA,
    AntecipacaoCategoria.MATERIAL_GRAFICO,
    AntecipacaoCategoria.CENOGRAFIA,
    AntecipacaoCategoria.TECNICA,
    AntecipacaoCategoria.TECNOLOGIA,
    AntecipacaoCategoria.SERVICOS,
    AntecipacaoCategoria.OUTROS,
];
/**
 * Rótulo tolerante a categoria removida do enum: snapshots antigos guardam o código, então cair
 * para o próprio código é melhor que renderizar vazio no histórico.
 */
export function rotuloAntecipacaoCategoria(categoria) {
    return AntecipacaoCategoriaMap[categoria] ?? String(categoria);
}
/**
 * A partir de quanto o adiantamento ganha o aviso de proporção alta. Qualquer antecipação já é
 * destacada; este é o segundo nível, que responde "isso é muito?" — decidido em 02/09/2026 após
 * um job passar com mais da metade adiantada. Constante de propósito: regra pontual demais para
 * virar configuração de admin (ver `docs/antecipacao-detalhada.md` §2).
 */
export const ANTECIPACAO_PERCENTUAL_ALERTA = 30;
